import { authApi } from '../authentication/authentication.actions';
import { 
  IDeviceVerificationRequest,
  IDeviceVerificationData,
  IDeviceVerificationGenerateCodeRequest,
  IDeviceVerificationGenerateCodeResponse,
  IDeviceVerificationCheckCodeRequest,
  IDeviceVerificationCheckCodeResponse
} from 'types/deviceVerification';
import { API_ROUTES } from '../../constants/API_ROUTES';

export const deviceVerificationApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    requestNewOtpSeed: builder.mutation<IDeviceVerificationData, IDeviceVerificationRequest>({
      query: (data) => ({
        url: API_ROUTES.auth.otpSeed.requestNew,
        method: 'POST',
        body: data,
        credentials: 'include',
      }),
      extraOptions: {
        bypassChecksum: true,
      },
    }),
    generateDeviceCode: builder.mutation<IDeviceVerificationGenerateCodeResponse, IDeviceVerificationGenerateCodeRequest>({
      query: (data) => ({
        url: API_ROUTES.auth.otpSeed.generateCode,
        method: 'POST',
        body: data,
        credentials: 'include',
      }),
      extraOptions: {
        bypassChecksum: true,
      },
    }),
    checkDeviceCode: builder.mutation<IDeviceVerificationCheckCodeResponse, IDeviceVerificationCheckCodeRequest>({
      query: (data) => ({
        url: API_ROUTES.auth.otpSeed.finish,
        method: 'POST',
        body: data,
        credentials: 'include',
      }),
      extraOptions: {
        bypassChecksum: true,
      },
    }),
  }),
});

export const {
  useRequestNewOtpSeedMutation,
  useGenerateDeviceCodeMutation,
  useCheckDeviceCodeMutation,
} = deviceVerificationApi; 